const isProductInWishlist = productCode => {
  if (window.reece && window.reece.wishlist) {
    return window.reece.wishlist.isProductInWishlist(productCode);
  }
  return false;
};

export default isProductInWishlist;